export const questionMixin = {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    onAnswer(value, delay = 300) {
      setTimeout(
        () => this.$emit('next', {question_id: this.question._id, value}),
        delay
      );
    }
  }
};

export const questionEventListenerMixin = {
  mounted() {
    document.addEventListener('keydown', this.onKeyDown, false);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }
};

export default questionMixin;
